import { Button, Icon, Modal } from "antd";
import moment from "moment";
import React from "react";
import { catchPhotoItem } from "service/exam";
import useModalHandler from "utils/useModalHandler";
import style from "./index.module.scss";

export default function ImageRecord({
    photoData
}: {
    photoData: catchPhotoItem;
}) {
    const modal = useModalHandler();

    return (
        <div className={style.root}>
            <div className={style.container}>
                <div className={style.image}>
                    <img src={photoData.fileUrl} className={style.icon} />
                </div>
                <div className={style.info}>
                    <div className={style.time}>
                        {moment(photoData.time).format("MM-DD HH:mm:ss")}
                    </div>
                    <Button type="link" onClick={modal.open}>
                        <Icon type="zoom-in" />
                    </Button>
                </div>
            </div>
            <Modal
                visible={modal.visible}
                footer={null}
                onCancel={modal.close}
                className={style.modal}>
                <img
                    alt="example"
                    style={{ width: "100%" }}
                    src={photoData.fileUrl}
                />
            </Modal>
        </div>
    );
}
